module.exports = __webpack_public_path__ + "b87ebccd3d53ba5d0089c40a98ff55fb.png";